import { ActionHandlerController } from './actions-handler.controller';
import { ActionsHandlerComponentProps } from './actions-handler.model';

const ActionHandler = (props: ActionsHandlerComponentProps): JSX.Element => {
  return <ActionHandlerController {...props} />;
};

export default ActionHandler;
